import type { Command } from 'common/Prose/Commands'
import { combineCommands } from 'common/Prose/utils/combineCommands'
import { schema } from 'prose-core'
import { splitListItem } from 'prosemirror-schema-list'

export const splitTaskListItem: Command = (state, dispatch) => {
  const { $from } = state.selection
  if ($from.depth < 2 || $from.node($from.depth - 2).type !== schema.nodes.check_list) return false // we're not inside a check_list
  if ($from.node().content.size === 0) return false // we're inside a check list, but it's empty, let the next command handle it
  const tr = combineCommands(state, [splitListItem(schema.nodes.list_item), clearUuidandTodoIDFromTaskListItem])

  if (tr) {
    dispatch?.(tr)
    return true
  }
  return false
}

const clearUuidandTodoIDFromTaskListItem: Command = (state, dispatch) => {
  const { selection, tr } = state
  const splitListItemPos = selection.$from.before(-1)
  const splitListItemNode = state.doc.resolve(splitListItemPos).nodeAfter
  if (splitListItemNode && splitListItemNode.type === schema.nodes.list_item) {
    dispatch?.(
      tr.setNodeMarkup(splitListItemPos, undefined, {
        ...splitListItemNode.attrs,
        todoId: null,
        uuid: null,
        checked: false,
      }),
    )
    return true
  }
  return false
}
